import React from "react";
import { Link } from "react-router-dom";
import "./back.scss";
import { useTranslation } from "react-i18next";
import ShowContainer from "../ShowContainer";
import IconArrow from "../JSXIcons/IconArrow";
import useColor from "../../../hooks/other/useColor";

export default function Back({ title, to, icon, onClick }) {
  const { t } = useTranslation();
  const { headerStyle } = useColor();

  return (
    <span className="back-row" onClick={onClick}>
      <Link to={to} className="arrow-back">
        <div className="arrow-back__btn">
          <IconArrow className="rotate90" />
        </div>
        <span className="arrow-back__text">{t("Back")}</span>
      </Link>

      <ShowContainer condition={title}>
        <span className="arrow-back__title">
          <ShowContainer condition={icon}>{icon}</ShowContainer>
          <h1 style={headerStyle}>{t(title)} </h1>
        </span>
      </ShowContainer>
    </span>
  );
}
